module.exports = __webpack_public_path__ + "img/front_neck_depth.32f7f6d4.png";